/**
 * Pure helpers for delivery workflow — shared by table UI and Excel export.
 * @param {Record<string, string>} [labels]
 * @param {string} [labels.estadoAsignado]
 * @param {string} [labels.estadoEnProceso]
 * @param {string} [labels.empty] displayed when no value (UI uses "—", Excel uses "")
 */

export function obtenerEstadoWorkflow(workflow, labels = {}) {
    const empty = labels.empty ?? "";
    if (!Array.isArray(workflow) || workflow.length === 0) return empty;
    if (workflow.length === 1) {
        return labels.estadoAsignado ?? "Asignado";
    }
    if (workflow.length === 2) {
        return labels.estadoEnProceso ?? "En proceso";
    }
    const ultimoEstado = workflow[workflow.length - 1];
    const desc = ultimoEstado?.descripcionEstado;
    if (desc == null || String(desc).trim() === "") return empty;
    return String(desc).trim();
}

export function obtenerSubEstadoWorkflow(workflow, labels = {}) {
    const empty = labels.empty ?? "";
    if (!Array.isArray(workflow) || workflow.length === 0) return empty;
    if (workflow.length <= 2) return empty;
    const ultimoEstado = workflow[workflow.length - 1];
    const desc = ultimoEstado?.descripcionSubEstado;
    if (desc == null || String(desc).trim() === "") return empty;
    return String(desc).trim();
}

/**
 * @returns {{ descripcion: string, detalle: string }}
 */
export function obtenerEstadoPagoWorkflow(workflow) {
    const empty = { descripcion: "", detalle: "" };
    if (!Array.isArray(workflow) || workflow.length === 0) return empty;

    const estadoFinalizado = workflow.filter((work) => work.finalizarProceso === 1);
    if (estadoFinalizado.length === 0) return empty;

    const finalizado = estadoFinalizado[0];
    try {
        const raw = finalizado?.jsonFormulario;
        const jsonFormulario =
            typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!Array.isArray(jsonFormulario)) return empty;

        const estadoDePago = jsonFormulario.find((form) => form.type === "estado_de_pago");
        if (
            !Array.isArray(estadoDePago?.estadoDePagoSelected) ||
            estadoDePago.estadoDePagoSelected.length === 0
        ) {
            return empty;
        }

        const selected = estadoDePago.estadoDePagoSelected[0];
        const descripcion =
            selected?.descripcion != null ? String(selected.descripcion).trim() : "";

        let detalle = "";
        if (Array.isArray(selected.dynamicFields) && selected.dynamicFields.length > 0) {
            detalle = selected.dynamicFields
                .map((field) => `${field.key || "-"}: ${field.value ?? "-"}`)
                .join("; ");
        }

        return { descripcion, detalle };
    } catch {
        return empty;
    }
}

/** Workflow fields for one delivery row (Excel / CSV). */
export function extractWorkflowFieldsForExport(item, workflowLabels = {}) {
    const workflow = item?.workflow;
    const pago = obtenerEstadoPagoWorkflow(workflow);
    return {
        estadoEntrega: obtenerEstadoWorkflow(workflow, workflowLabels),
        subEstadoEntrega: obtenerSubEstadoWorkflow(workflow, workflowLabels),
        estadoPagoWorkflow: pago.descripcion,
        estadoPagoDetalle: pago.detalle,
    };
}
